export default "__VITE_ASSET__B7eLpr0J__"